import angular from 'angular';
import { AfastadosService } from '../afastados.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';
import { IAfastado, IAfastadoBody, IRelatorioAfastadoBody } from '../models/afastados.model';

type IAfastadosIndexFilter = {
    empresa?: string;
    estabelecimento?: string;
    visualizacao: number;
    motivoafastamento?: string;
    data?: string;
    datainicio?: string;
    datafim?: string;
    search?: string;
    lotacao?: {
        lotacao: string;
    } | null;
    departamento?: {
        departamento: string;
    } | null;
};

export class AfastadosIndexController {
    static $inject = [
        '$rootScope',
        'NewToaster',
        'AfastadosService',
        'RelatoriosService',
        'ListagemService',
    ];

    public entity: IAfastado[] = [];
    public busy: boolean;
    public loading = {
        pdf: false,
        xlsx: false,
        csv: false
    };
    public todosSelecionados = false;
    public listagemPermissao = ['visualizar_afastamentos'];
    public permissaoGrupoEmpresarial = false;
    public estabelecimentos: Estabelecimento[];
    public empresas: Empresa[];
    public filters: IAfastadosIndexFilter = {
        visualizacao: 1,
    };
    public motivos = [
        {
            id: 0,
            descricao: 'Acidente de Trabalho',
            tipohistorico: '001'
        }, {
            id: 1,
            descricao: 'Prorrogação decorrente do mesmo acidente de trabalho',
            tipohistorico: '002'
        }, {
            id: 2,
            descricao: 'Doença',
            tipohistorico: '003'
        }, {
            id: 3,
            descricao: 'Acidente não relacionado ao trabalho',
            tipohistorico: '003'
        }, {
            id: 4,
            descricao: 'Prorrogação decorrente da mesma doença',
            tipohistorico: '004'
        }, {
            id: 5,
            descricao: 'Prorrogação decorrente do mesmo acidente não relacionado ao trabalho',
            tipohistorico: '004'
        }, {
            id: 6,
            descricao: 'Paternidade',
            tipohistorico: '005'
        }, {
            id: 7,
            descricao: 'Maternidade',
            tipohistorico: '006'
        }, {
            id: 8,
            descricao: 'Maternidade de filho com microencefalia',
            tipohistorico: '033'
        }, {
            id: 9,
            descricao: 'Maternidade por aborto expontâneo',
            tipohistorico: '008'
        }, {
            id: 10,
            descricao: 'Serviço militar',
            tipohistorico: '009'
        }, {
            id: 11,
            descricao: 'Licença não remunerada ou sem vencimentos',
            tipohistorico: '011'
        }, {
            id: 12,
            descricao: 'Suspensão',
            tipohistorico: '018'
        }, {
            id: 13,
            descricao: 'Licença remunerada',
            tipohistorico: '025'
        }, {
            id: 14,
            descricao: 'Adoção',
            tipohistorico: '026'
        }, {
            id: 15,
            descricao: 'Guarda judicial de criança',
            tipohistorico: '026'
        }, {
            id: 16,
            descricao: 'Vítima de violência - Lei Maria da Penha',
            tipohistorico: '028'
        }, {
            id: 17,
            descricao: 'Prorrogação de licença maternidade',
            tipohistorico: '035'
        },
    ];

    constructor(
        public $rootScope: angular.IRootScopeService & {
            modoGestorPermissao: (arg: string) => boolean,
            temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
            session: any,
            nsjGlobals: any,
        },
        public NewToaster: { pop: Function },
        public AfastadosService: AfastadosService,
        public RelatoriosService: any,
        public ListagemService: ListagemService,
    ) {
        this.filters = {
            ...this.filters,
            empresa: $rootScope.session.entities.empresa.empresa,
            estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
        };

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

        this.montaListagemVisibilidade();
    }

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial, this.listagemPermissao);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas, this.listagemPermissao);
    }

    mudaEstabelecimentos() {
        this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao) : [];
        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    filtraEmpresaEstabelecimento() {
        delete this.filters.lotacao;
        delete this.filters.departamento;
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.$rootScope.$broadcast('departamento_refresh', this.constructorEmpresaEstabelecimento());
        this.carregarRelatorio();
    }

    carregarRelatorio() {
        const construtor = {
            ...this.setConstructor(),
            ...this.getColaboradoresSelecionados(),
        };
        this.busy = true;
        this.entity = [];
        this.AfastadosService.getAfastados(construtor as IAfastadoBody)
            .then((response) => this.entity = response)
            .finally(() => this.busy = false);
    }

    exportarRelatorio(format: IRelatorioAfastadoBody['format']) {
        if (!format) {
            return;
        }
        const construtor = {
            ...this.setConstructor(),
            ...this.getColaboradoresSelecionados(),
            format
        };
        this.loading[format] = true;
        this.AfastadosService.getRelatorioAfastados(construtor as IRelatorioAfastadoBody)
            .then((response) => {
                const fileName = `relatorio_afastados.${format}`;
                this.handleDownload(response.data, fileName, 'application/octet-stream');
            })
            .finally(() => this.loading[format] = false);
    }

    getColaboradoresSelecionados() {
        const algumSelecionado = this.peloMenosUmSelecionado();
        const trabalhadores = {
            ...(algumSelecionado && { trabalhadores: this.montaArrayColaboradoresSelecionados() }),
        };
        return trabalhadores;
    }

    setConstructor() {
        const filtro = Object.fromEntries(
            Object.entries(this.filters).filter(([_, v]) => this.valorExiste(v))
        );
        return {
            ...filtro,
            ...(this.filters.lotacao?.lotacao && { lotacao: this.filters.lotacao.lotacao }),
            ...(this.filters.departamento?.departamento && { departamento: this.filters.departamento.departamento })
        };
    }

    constructorEmpresaEstabelecimento() {
        return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
    }

    mudaVisualizacao() {
        this.filters.data = '';
        this.filters.datainicio = '';
        this.filters.datafim = '';
        if (this.filters.visualizacao > 2) {
            return;
        }
        this.carregarRelatorio();
    }

    visualizacaoPorData() {
        if (!this.filters.data) {
            return;
        }
        this.carregarRelatorio();
    }

    visualizacaoEntreDatas() {
        if (!this.filters.datainicio || !this.filters.datafim) {
            return;
        }
        this.carregarRelatorio();
    }

    montaArrayColaboradoresSelecionados() {
        return this.entity.filter(colaborador => colaborador.selected)
            .map(colaborador => {
                return { trabalhador: colaborador.trabalhador };
            });
    }

    peloMenosUmSelecionado() {
        return this.entity.some(colaborador => colaborador.selected);
    }

    setTodosSelecionados() {
        this.entity.forEach(colaborador => {
            colaborador.selected = this.todosSelecionados;
        });
    }

    atualizaTodosSelecionados() {
        this.todosSelecionados = this.entity.every(colaborador => colaborador.selected);
    }

    handleDownload(file: File, name: string, type?: string) {
        const blob = new Blob([file], { type });
        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(fileURL);
    }

    valorExiste(valor: any) {
		return valor !== '' && valor !== undefined && valor !== null ? true : false;
	}
}
